<template>
  <div class="approvalOperation">
    <el-collapse v-model="activeNames">
      <el-collapse-item name="operation">
        <template #title>
          <span>
            <img src="../../assets/svg/approvalOperation.svg" alt="" />
            审批操作
          </span>
        </template>
        <div>
          <kdSwitchMainAudit :taskId="taskId"></kdSwitchMainAudit>
        </div>
      </el-collapse-item>
    </el-collapse>
  </div>
</template>
<script>
import kdSwitchMainAudit from "../kdAuditForm/kdSwitchMainAudit.vue";
export default {
  name: "operation",
  props: {
    taskId: {
      type: String,
      default: "",
    },
  },
  components: {
    kdSwitchMainAudit,
  },
  data() {
    return {
      activeNames: ["operation"], // 全部展开
    };
  },
};
</script>
